import Image from "next/image"
import TrustpilotGoogleReviews from "../../components/TrustpilotGoogleReviews"
import Breadcrumb from "../../components/breadcrumbs"
import PageNav from "../../storyblok/sections/PageNav"
import CostToShipForm from "./CostToShipForm"
import Stats from "./Stats"

export default function CostToShipHeader({
  metroName,
  stateCode,
}: {
  metroName: string
  stateCode: string
}) {
  return (
    <section className="relative w-full p-0 m-0 -mb-[2px] bg-cover overflow-x-hidden">
      <Image src="/images/hero_bg.webp" alt="shipping cost" fill />
      <PageNav noBlok buttonLabel="Get Free Transport Quotes" />

      <header className="relative header-padding pt-24 md:pt-32 w-full flex flex-col md:flex-row md:gap-10 lg:gap-14 xl:gap-20 overflow-hidden">
        <section className="w-full max-w-none md:w-3/5 lg:w-full lg:max-w-xl 2xl:max-w-2xl">
          <div className="mb-8">
            <Breadcrumb
              items={[
                { name: "Home", href: "/" },
                { name: "Cost to Ship", href: "/cost-to-ship" },
                { name: `${metroName}, ${stateCode}`, href: "/cost-to-ship" },
              ]}
            />
          </div>
          <div className="h-fit bg-white p-6 rounded-xl space-y-6 drop-shadow">
            <h1 className="m-0 text-blue7 text-4xl lg:text-5xl font-semibold font-montserrat">
              Discover the cost to ship your beloved pets and most precious
              items to or from {metroName}, {stateCode}
            </h1>
            <h2 className="text-lg font-normal text-blue5">
              Transport anything safely to {metroName} for as little as
              <strong className="font-semibold"> 54 cents per mile.</strong>
            </h2>
            <CostToShipForm />
          </div>
        </section>
        <aside className="relative md:w-2/5 lg:w-full mt-6 md:mt-0 grow flex flex-col">
          <Polaroids />
          <TrustpilotGoogleReviews className="mt-auto md:flex-col lg:flex-row lg:ml-auto 2xl:mx-auto md:scale-90 lg:scale-100" />
        </aside>
      </header>
      <Stats />
    </section>
  )
}

function Polaroids() {
  return (
    <div className="hidden grow md:flex w-full relative items-center justify-end">
      <Image
        className="absolute w-3/4 scale-90 max-w-lg h-fit -translate-x-24 lg:-translate-x-36 drop-shadow object-contain"
        src="/images/car-polaroid.webp"
        alt="Cost to ship a car"
        width={390}
        height={548}
        priority
      />
      <Image
        className="w-3/4 max-w-lg h-fit drop-shadow object-contain"
        src="/images/boy-dog-polaroid.webp"
        alt="Dog shipped to family after discovering cost to ship a dog"
        width={390}
        height={548}
        priority
      />
    </div>
  )
}
